import * as React from 'react';

const SvgSimCard = (props) => (
  <svg
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M21.3333 30.3327H10.6667C6.08 30.3327 3 27.2527 3 22.666V9.33268C3 4.74602 6.08 1.66602 10.6667 1.66602H17.24C19.2933 1.66602 21.2133 2.46602 22.6667 3.90602L26.76 7.99935C28.2133 9.45268 29 11.3727 29 13.426V22.666C29 27.2527 25.92 30.3327 21.3333 30.3327ZM10.6667 3.66602C7.22667 3.66602 5 5.89268 5 9.33268V22.666C5 26.106 7.22667 28.3327 10.6667 28.3327H21.3333C24.7733 28.3327 27 26.106 27 22.666V13.426C27 11.9193 26.4133 10.4927 25.3333 9.41268L21.24 5.33268C20.1733 4.26602 18.7467 3.66602 17.2267 3.66602H10.6667Z'
      fill='#E00034'
    />
    <path
      d='M18.6668 25.666H13.3335C10.5735 25.666 8.3335 23.426 8.3335 20.666V16.666C8.3335 13.906 10.5735 11.666 13.3335 11.666H18.6668C21.4268 11.666 23.6668 13.906 23.6668 16.666V20.666C23.6668 23.426 21.4268 25.666 18.6668 25.666ZM13.3335 13.666C11.6802 13.666 10.3335 15.0127 10.3335 16.666V20.666C10.3335 22.3193 11.6802 23.666 13.3335 23.666H18.6668C20.3202 23.666 21.6668 22.3193 21.6668 20.666V16.666C21.6668 15.0127 20.3202 13.666 18.6668 13.666H13.3335Z'
      fill='#E00034'
    />
    <path
      d='M16 25.666C15.4533 25.666 15 25.2127 15 24.666V12.666C15 12.1193 15.4533 11.666 16 11.666C16.5467 11.666 17 12.1193 17 12.666V24.666C17 25.2127 16.5467 25.666 16 25.666Z'
      fill='#E00034'
    />
    <path
      d='M22 19.666H10C9.45333 19.666 9 19.2127 9 18.666C9 18.1193 9.45333 17.666 10 17.666H22C22.5467 17.666 23 18.1193 23 18.666C23 19.2127 22.5467 19.666 22 19.666Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgSimCard;
